import styled from 'styled-components';

export const Upper = styled.div`
  > * {
    text-transform: uppercase;
  }
`;
